import React, { Component } from 'react'
import numeral from "numeral";
import * as d3 from "d3";
import tooltip from "./Tooltip.js";
import utils from "./utils.js";
const customFormat = (value, format, index) => {
  if(typeof format === 'string'){
    return numeral(value).format(format)
  } else if (typeof format === 'function') {
    return format(value, index)
  }else{
    return value;
  }
}

export default class Bars extends Component {
  constructor(props) {
    super(props)

    // this.colorScale = scaleLinear()
    //   .domain([0, this.props.maxValue])
    //   .range(['#F3E5F5', '#7B1FA2'])
    //   .interpolate(interpolateLab)
  }
  componentDidUpdate(){
  }
  onColumnBarClick=(xAxisLabels,yAxisValue,name,oriDatum,xAxisPosition,yAxisPosition,xAxisScale,yAxisScale,tooltipStyle,height,margins,id,showColumnChartTooltip,datum,closeIconStyle,tooltipConfig)=>{
    oriDatum.tooltipConfig=tooltipConfig || {};
    var data={
      xAxisLabels:xAxisLabels,
      yAxisValue:yAxisValue,
      name:name,
      data: oriDatum,
      positionInfo:{x:xAxisPosition,yPos:yAxisPosition,bandwidth:xAxisScale.scale.bandwidth(),y:(yAxisScale.scale(datum)),tooltipStyle:tooltipStyle,barHeight:(height - margins.bottom - yAxisScale.scale(datum)),id:id,isDataTip:true,closeIconStyle:closeIconStyle}
    };
    if(this.props.onColumnBarClick!=undefined && (oriDatum.enableClick==undefined || oriDatum.enableClick==true) ){
      hideDetail();
      this.props.onColumnBarClick(data);
      // this.props.hideColumnChartTooltip();
      // this.props.onColumnBarClick(data,function(result){
      //   if(result.component && typeof(result.component)=='object'){
      //     showColumnChartTooltip(result.component,{x:xAxisPosition,bandwidth:xAxisScale.scale.bandwidth(),y:(yAxisScale.scale(datum)),tooltipStyle:tooltipStyle,barHeight:(height - margins.bottom - yAxisScale.scale(datum)),id:id,isDataTip:true});
      //   }
      // });
    }
  }
  onBarMouseEnter=(tooltip,globalTooltip,mainDivId,margins,xAxisPosition,yAxisPosition,xAxisTooltipsLabel,datum,name,mouseEvent,globalTooltipData,tooltipStyle,tooltipPosition,xAxisScale,yAxisScale,id,showColumnChartTooltip,oriDatum,onColumnBarClick,fillColor,hoverStyle,height,typeOfTooltip,tooltipData)=>{
    tooltip ? (tooltip===true || globalTooltip==true) ? 
          showDetail({id:mainDivId,margins:margins,tooltip:tooltip,x:xAxisPosition || {},y:yAxisPosition || {}},[{[name]:datum,name:xAxisTooltipsLabel}],mouseEvent,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition,typeOfTooltip,tooltipData) :
          showColumnChartTooltip(tooltip ||'<g class="tooltipg"></g>',{x:xAxisPosition,yPos:yAxisPosition,bandwidth:xAxisScale.scale.bandwidth(),y:(yAxisScale.scale(datum)),tooltipStyle:tooltipStyle,barHeight:(height - margins.bottom - yAxisScale.scale(datum)),id:id}): '';
    
    if(hoverStyle!=undefined){
        if(hoverStyle.hasOwnProperty('labelStyle')==true){
          var textStyle='text-anchor:middle;';
          var globalData=JSON.parse(mouseEvent.target.getAttribute("data") || "{}");
          var dataIndex=globalData["dataIndex"];
          d3.selectAll(".multiseries-bar-text_"+dataIndex).attr("style",utils.convertReactStyleToHtml(hoverStyle.labelStyle,textStyle));
        }
        if(hoverStyle.hasOwnProperty('barStyle')==true){
          var cursorStyle=onColumnBarClick ?
            ((oriDatum!=null && typeof(oriDatum)!='object')) ? "pointer" :((oriDatum!=null && typeof(oriDatum)=='object') && (oriDatum.enableClick==undefined || oriDatum.enableClick==true)) ?"pointer":"default"
           : "default";
          var rectStyle='cursor:'+cursorStyle+';fill:'+((oriDatum!=null && typeof(oriDatum)=='object') ?(oriDatum.fillColor==undefined ? fillColor : oriDatum.fillColor) : fillColor)+';';
          mouseEvent.target.setAttribute("style",utils.convertReactStyleToHtml(hoverStyle.barStyle,rectStyle));
        }
    }
    if((oriDatum!=null && typeof(oriDatum)=='object')){
      if(oriDatum.hoverLabelStyle!=undefined && oriDatum.enableClick==true &&  typeof(oriDatum.hoverLabelStyle)=='object'){
        var textStyle='text-anchor:middle;';
        var globalData=JSON.parse(mouseEvent.target.getAttribute("data") || "{}");
        var dataIndex=globalData["dataIndex"];
        d3.selectAll(".multiseries-bar-text_"+dataIndex).attr("style",utils.convertReactStyleToHtml(oriDatum.hoverLabelStyle,textStyle));
      }
      if(oriDatum.hoverBarStyle!=undefined && oriDatum.enableClick==true &&  typeof(oriDatum.hoverBarStyle)=='object'){
        var cursorStyle=onColumnBarClick ?
            ((oriDatum!=null && typeof(oriDatum)!='object')) ? "pointer" :((oriDatum!=null && typeof(oriDatum)=='object') && (oriDatum.enableClick==undefined || oriDatum.enableClick==true)) ?"pointer":"default"
           : "default";
        var stroke=(oriDatum!=null && typeof(oriDatum)=='object') ? (oriDatum.stroke ? oriDatum.stroke : "transparent") : "transparent" ; 
        var strokeWidth=(oriDatum!=null && typeof(oriDatum)=='object') ? (oriDatum.strokeWidth ? oriDatum.strokeWidth : "0px") : "0px" ; 
        var rectStyle='cursor:'+cursorStyle+';fill:'+((oriDatum!=null && typeof(oriDatum)=='object') ?(oriDatum.fillColor==undefined ? fillColor : oriDatum.fillColor) : fillColor)+';stroke:'+stroke+";stroke-width:"+strokeWidth+";";
        mouseEvent.target.setAttribute("style",utils.convertReactStyleToHtml(oriDatum.hoverBarStyle,rectStyle));
      }
    }
    

  }
  onBarMouseOut=(tooltip,globalTooltip,hideColumnChartTooltip,mouseEvent,oriDatum,fillColor,onColumnBarClick,dataLabels,hoverStyle)=>{
    tooltip ? (tooltip===true || globalTooltip==true) ? hideDetail() :hideColumnChartTooltip() : '';
    if(hoverStyle!=undefined){
        if(hoverStyle.hasOwnProperty('labelStyle')==true){
          var textStyle='text-anchor:middle;fill:#000;font-size:12px;font-weight:normal';
          var globalData=JSON.parse(mouseEvent.target.getAttribute("data") || "{}");
          var dataIndex=globalData["dataIndex"];
          d3.selectAll(".multiseries-bar-text_"+dataIndex).attr("style",utils.convertReactStyleToHtml(dataLabels && dataLabels.style ? dataLabels.style :{},textStyle));
        }
        if(hoverStyle.hasOwnProperty('barStyle')==true){
          var cursorStyle=onColumnBarClick ?
            ((oriDatum!=null && typeof(oriDatum)!='object')) ? "pointer" :((oriDatum!=null && typeof(oriDatum)=='object') && (oriDatum.enableClick==undefined || oriDatum.enableClick==true)) ?"pointer":"default"
          : "default";
          var rectStyle='cursor:'+cursorStyle+';fill:'+((oriDatum!=null && typeof(oriDatum)=='object') ?(oriDatum.fillColor==undefined ? fillColor : oriDatum.fillColor) : fillColor)+';';
          mouseEvent.target.setAttribute("style",rectStyle);
        }
    }
    if((oriDatum!=null && typeof(oriDatum)=='object')){
      if(oriDatum.hoverLabelStyle!=undefined && oriDatum.enableClick==true &&  typeof(oriDatum.hoverLabelStyle)=='object'){
        var textStyle='text-anchor:middle;fill:#000;font-size:12px;font-weight:normal';
        var globalData=JSON.parse(mouseEvent.target.getAttribute("data") || "{}");
        var dataIndex=globalData["dataIndex"];
        d3.selectAll(".multiseries-bar-text_"+dataIndex).attr("style",utils.convertReactStyleToHtml(dataLabels && dataLabels.style ? dataLabels.style :{},textStyle));
      }
      if(oriDatum.hoverBarStyle!=undefined && oriDatum.enableClick==true &&  typeof(oriDatum.hoverBarStyle)=='object'){
        var cursorStyle=onColumnBarClick ?
            ((oriDatum!=null && typeof(oriDatum)!='object')) ? "pointer" :((oriDatum!=null && typeof(oriDatum)=='object') && (oriDatum.enableClick==undefined || oriDatum.enableClick==true)) ?"pointer":"default"
           : "default";
           var stroke=(oriDatum!=null && typeof(oriDatum)=='object') ? (oriDatum.stroke ? oriDatum.stroke : "transparent") : "transparent" ; 
        var strokeWidth=(oriDatum!=null && typeof(oriDatum)=='object') ? (oriDatum.strokeWidth ? oriDatum.strokeWidth : "0px") : "0px";
        var rectStyle='cursor:'+cursorStyle+';fill:'+((oriDatum!=null && typeof(oriDatum)=='object') ?(oriDatum.fillColor==undefined ? fillColor : oriDatum.fillColor) : fillColor)+';stroke:'+stroke+";stroke-width:"+strokeWidth+";";
        mouseEvent.target.setAttribute("style",rectStyle);
      }
    }
  }
  render() {
    var that=this;
    const { yAxisScale,xAxisScale, margins, data, svgDimensions,fillColor,isGroupColumn,isGroupBar,groupIndex,mainGroupIndex,xAxisData,dataLabels,tooltip,id,name,mainDivId,
            showColumnChartTooltip,hideColumnChartTooltip,globalTooltip,globalTooltipData,tooltipStyle,primaryXAxis,tooltipPosition,hoverStyle,
            closeIconStyle,tooltipConfig,isGroupDataHaveNegativeValue } = this.props;
    const xAxisCategory=(this.props.xAxisCategory!=null && typeof(this.props.xAxisCategory)=='object') ? this.props.xAxisCategory["data"] : this.props.xAxisCategory;                  
    const { height,width } = svgDimensions;
    var defaultDataLabelFormat=function(d){
      return d;
    };//"0,0.[00]"
    tooltipStyle.format= tooltipStyle.format!=undefined ? tooltipStyle.format : ((yAxisScale.labels && yAxisScale.labels.format) || defaultDataLabelFormat);
    tooltipStyle.prefix= tooltipStyle.prefix!=undefined ? tooltipStyle.prefix : ((yAxisScale.labels && yAxisScale.labels.prefix) || '');
    tooltipStyle.postfix= tooltipStyle.postfix!=undefined ? tooltipStyle.postfix : ((yAxisScale.labels && yAxisScale.labels.postfix) || '');
    var isDataHaveNegativeValue=(isGroupDataHaveNegativeValue!=null) ? isGroupDataHaveNegativeValue : data.filter(function(datum){
      var oriDatum=datum;  
      if(datum!=null && typeof(datum)=='object'){
        oriDatum=datum.data;
      }
      return oriDatum<0;
    }).length;
    isDataHaveNegativeValue=isDataHaveNegativeValue>0 ? 1 : 0;
    const bars = 
      data.map(function(datum,index) {
        var oriDatum=datum;  
        if(datum!=null && typeof(datum)=='object'){
          oriDatum=$.extend({},false,(datum==null) ? {} : datum);
          datum=datum.data;
        }
        var xAxisLabels=(isGroupColumn || isGroupBar) ? ("groupDomain"+"_"+groupIndex) : ((xAxisData[index]!=null && typeof(xAxisData[index])=='object') ? xAxisData[index].data : xAxisData[index]) ;
        var xAxisTooltipsLabel=(isGroupColumn || isGroupBar) ? xAxisCategory : ((xAxisData[index]!=null && typeof(xAxisData[index])=='object') ? xAxisData[index].data : xAxisData[index]);
        var xAxisPosition=(isGroupColumn || isGroupBar ? (primaryXAxis.scale(xAxisCategory)+(xAxisScale.scale(xAxisLabels))) :(xAxisScale.scale(xAxisLabels)))+(xAxisScale.scale.bandwidth()/2);
        var yAxisPosition=(datum > 0 ? yAxisScale.scale(datum) :(yAxisScale.scale(0)));
        if(isGroupBar==1){
          const oldXPosition=xAxisPosition;
          xAxisPosition=isDataHaveNegativeValue ? (datum > 0 ? (yAxisScale.scale(0)) :(yAxisScale.scale(datum)))+((datum > 0 ? (isDataHaveNegativeValue ? (yAxisScale.scale(datum)-yAxisScale.scale(0)) : (yAxisScale.scale(datum)-margins.left)):
          (yAxisScale.scale(0)-(yAxisScale.scale(datum))))/2) : yAxisPosition/2;
          yAxisPosition=oldXPosition-(xAxisScale.scale.bandwidth()/2);
        }
        var globalData={xAxisTooltipsLabel:xAxisTooltipsLabel,
          dataIndex:(isGroupColumn || isGroupBar) ? mainGroupIndex : index,
          xAxisPosition:xAxisPosition,
          yAxisPosition:yAxisPosition
        }
        return (<rect
          className={that.props.onColumnBarClick ? "multiseries-bar-blinkonMOver" :""}
          key={"data_"+index+"_"+xAxisLabels+"_"+name}
          x={isGroupBar ? ( datum > 0 ? (yAxisScale.scale(0)-margins.left) :(yAxisScale.scale(datum)-margins.left)) : xAxisScale.scale(xAxisLabels)}
          y={ isGroupBar ? xAxisScale.scale(xAxisLabels) : (datum > 0 ? yAxisScale.scale(datum) :(yAxisScale.scale(0)))}
          height={isGroupBar ? xAxisScale.scale.bandwidth() : datum > 0 ? ((isDataHaveNegativeValue ? yAxisScale.scale(0) : (height - margins.bottom)) - yAxisScale.scale(datum)) :
            (yAxisScale.scale(datum)-(yAxisScale.scale(0)))}
          width={isGroupBar ? datum > 0 ? (isDataHaveNegativeValue ? (yAxisScale.scale(datum)-yAxisScale.scale(0)) : (yAxisScale.scale(datum)-margins.left)):
            (yAxisScale.scale(0)-(yAxisScale.scale(datum)))  : xAxisScale.scale.bandwidth()}
          fill={(oriDatum!=null && typeof(oriDatum)=='object') ?(oriDatum.fillColor==undefined ? fillColor : oriDatum.fillColor) : fillColor}
          style={{cursor:that.props.onColumnBarClick ?
            ((oriDatum!=null && typeof(oriDatum)!='object')) ? "pointer" :((oriDatum!=null && typeof(oriDatum)=='object') && (oriDatum.enableClick==undefined || oriDatum.enableClick==true)) ?"pointer":"default"
           : "default",
           stroke:(oriDatum!=null && typeof(oriDatum)=='object') ? (oriDatum.stroke ? oriDatum.stroke : "transparent") : "transparent" ,
           strokeWidth:(oriDatum!=null && typeof(oriDatum)=='object') ? (oriDatum.strokeWidth ? oriDatum.strokeWidth : "0px") : "0px",
           outlineColor:(oriDatum != null && typeof (oriDatum) == 'object' && oriDatum.outlineColor != null) ? (oriDatum.outlineColor) :'transparent',
           outlineStyle:(oriDatum != null && typeof (oriDatum) == 'object' && oriDatum.outlineStyle != null) ? (oriDatum.outlineStyle) :'hidden',
           outlineWidth:(oriDatum != null && typeof (oriDatum) == 'object' && oriDatum.outlineWidth != null) ? (oriDatum.outlineWidth) :'0px',
           outlineOffset:(oriDatum != null && typeof (oriDatum) == 'object' && oriDatum.outlineOffset != null) ? (oriDatum.outlineOffset) :'0px'
          }}
          onClick={()=>{that.onColumnBarClick(xAxisTooltipsLabel,datum,name,((oriDatum!=null && typeof(oriDatum)=='object') ? oriDatum : {}),xAxisPosition,yAxisPosition,xAxisScale,yAxisScale,tooltipStyle,height,margins,id,showColumnChartTooltip,datum,closeIconStyle,tooltipConfig)}}
          data={JSON.stringify(globalData)}
          onMouseEnter={(mouseEvent,index)=>{that.onBarMouseEnter(tooltip,globalTooltip,mainDivId,margins,xAxisPosition,yAxisPosition,xAxisTooltipsLabel,datum,name,mouseEvent,globalTooltipData,tooltipStyle,tooltipPosition,xAxisScale,yAxisScale,id,showColumnChartTooltip,oriDatum,that.props.onColumnBarClick,fillColor,hoverStyle,height,(oriDatum != null && typeof (oriDatum) == 'object' && oriDatum.typeOfTooltip != null) ? (oriDatum.typeOfTooltip):null,(oriDatum != null && typeof (oriDatum) == 'object' && oriDatum.tooltipData != null) ? (oriDatum.tooltipData):null)}}
          onMouseOut={(mouseEvent,index)=>{
            that.onBarMouseOut(tooltip,globalTooltip,hideColumnChartTooltip,mouseEvent,oriDatum,fillColor,that.props.onColumnBarClick,dataLabels,hoverStyle);
          }}
          onMouseMove={(mouseEvent,index)=>{tooltip ? ((tooltip===true || globalTooltip==true) && tooltipPosition.toLowerCase()=='cursor') ? 
          showDetail({id:mainDivId,margins:margins,tooltip:tooltip,x:xAxisPosition || {},y:yAxisPosition || {}},[{[name]:datum,name:xAxisTooltipsLabel}],mouseEvent,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition,(oriDatum != null && typeof (oriDatum) == 'object' && oriDatum.typeOfTooltip != null) ? (oriDatum.typeOfTooltip):null,(oriDatum != null && typeof (oriDatum) == 'object' && oriDatum.tooltipData != null) ? (oriDatum.tooltipData):null):'' : ''}}
        />)
      });
    
    var format=dataLabels.format || (yAxisScale.labels && yAxisScale.labels.format) || defaultDataLabelFormat;
    var prefix=dataLabels.prefix || (yAxisScale.labels && yAxisScale.labels.prefix) || "";
    var postfix=dataLabels.postfix || (yAxisScale.labels && yAxisScale.labels.postfix) || "";
    const text = 
      data.map(function(datum,index) {
      var oriDatum=datum;  
      if(datum!=null && typeof(datum)=='object'){
        oriDatum=$.extend({},false,(datum==null) ? {} : datum);
        datum=datum.data;
      }
      var xAxisLabels=(isGroupColumn || isGroupBar) ? ("groupDomain"+"_"+groupIndex) : ((xAxisData[index]!=null && typeof(xAxisData[index])=='object') ? xAxisData[index].data : xAxisData[index]);

        return (<text
          key={index}
          x={isGroupBar ?(datum > 0 ? ((yAxisScale.scale(datum)-margins.left))+5:((yAxisScale.scale(0)-margins.left))+5):xAxisScale.scale(xAxisLabels)+(xAxisScale.scale.bandwidth()/2)}
          y={isGroupBar ? (xAxisScale.scale(xAxisLabels)+(xAxisScale.scale.bandwidth()/2)):(datum > 0 ? yAxisScale.scale(datum) :(yAxisScale.scale(0)))-5}
          fill={'#000'}
          className={"multiseries-bar-text_"+index}
          style={$.extend({'textAnchor':isGroupBar ? 'start':'middle','fontSize':"12px",fontWeight:'normal'},false,(dataLabels && dataLabels.style ? dataLabels.style :{}))}
        >{prefix+""+customFormat(datum,format)+""+postfix}</text>)
      });

    return (
      <g>{bars}{(dataLabels && dataLabels.enabled==true) && text}
          { React.Children.count(this.props.children) ? 
            <g className="columnBarChildComponent">
              { React.Children.map(this.props.children,function(child,index){
                  return (<g key={index}  className="columnBarChildComponent">{child}</g>);
                })
              }
            </g> 
            : null
          }  
      </g>
    )
  }
}

export function showDetail(props, data, mouseEvent,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition,typeOfTooltip,tooltipData) {
  var labelFontSize =tooltipStyle.labelFontSize ||  "12px";
  var labelFontColor =tooltipStyle.labelFontColor ||  "black";
  var labelFontFamily = tooltipStyle.labelFontFamily ||  "";
  var valueFontSize =tooltipStyle.valueFontSize ||  "12px";
  var valueFontColor =tooltipStyle.valueFontColor ||  "black";
  var valueFontFamily =tooltipStyle.valueFontFamily ||  "";
  if(props.tooltip===true){
    var x=props.x;
    var y=props.y;
    var defaultDataLabelFormat=function(d){
      return d;
    };//"0,0.[00]"
    var format=tooltipStyle.format || defaultDataLabelFormat;
    var prefix=tooltipStyle.prefix || '';
    var postfix=tooltipStyle.postfix || '';
    data.map(function(d,index) {
      if(typeOfTooltip=="html"){
        d["content"]=tooltipData;
      }else{
        let content = `<tr>
          <td colspan="2" class="value"  style="text-align: center;letter-spacing: 1.04px;line-height: 1.2;font-size:${valueFontSize};font-family:${valueFontFamily};color:${valueFontColor}">${
        d["name"]
        }</td></tr>`;
        delete d.name;
        var tooltipsContents = Object.keys(d);
        tooltipsContents.map(function(data) {
          content =
            content +
            `<tr><td class="key" style="letter-spacing: 1.04px;line-height: 1.2;font-size:${labelFontSize};font-family:${labelFontFamily};color:${labelFontColor}">${data} </td>
                <td class="value" style="letter-spacing: 1.04px;line-height: 1.2;font-size:${valueFontSize};font-family:${valueFontFamily};color:${valueFontColor}">${
                  prefix +customFormat(d[data],format,index)+postfix
            }</td></tr>`;
        });

    
        d["content"] = content;
      }
      d["x"] = (tooltipPosition=="cursor") ? mouseEvent.clientX : x+ $("#" + props.id).offset().left;//d3.event.x;
      d["y"] = (tooltipPosition=="cursor") ? mouseEvent.clientY : y+ $("#" + props.id).offset().top;// d3.event.y;
      d["mainDivId"] = props.id;
      d["marginLeft"] = props.margins.left;
      d["marginTop"] = props.margins.top;
    });
    tooltip.showTooltip(data, d3.event, "tooltip_map",(tooltipPosition=="cursor") ?  true :false,globalTooltip);
  }else{
  }  
  
}

export function hideDetail(d) {
  tooltip.hideTooltip();
}
